// // import { useState, useEffect, useRef, useCallback } from "react";
// // import { useParams, useNavigate, useLocation } from "react-router-dom";
// // import {
// //   Box,
// //   Paper,
// //   BottomNavigation,
// //   BottomNavigationAction,
// //   Badge,
// //   Typography,
// //   IconButton,
// // } from "@mui/material";
// // import HomeIcon from "@mui/icons-material/Home";
// // import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
// // import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// // import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// // import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
// // import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// // import { useSelector, useDispatch } from "react-redux";
// // import {
// //   fetchPublicMenu,
// //   fetchPublicOffers,
// //   selectRestaurantInfo,
// //   selectMenuError,
// //   selectMenuLoading,
// //   resetMenuError,
// // } from "../../redux/slices/publicSlice";
// // import PaymentErrorDialog from "./PaymentErrorDialog";

// // // Import all tab pages
// // import HomePage from "./tabs/HomePage";
// // import PublicMenuPage from "./tabs/PublicMenuPage";
// // import OffersPage from "./tabs/OffersPage";
// // import OrdersPage from "./tabs/OrdersPage";
// // import AccountPage from "./tabs/AccountPage";

// // // ── Tab config ────────────────────────────────────
// // const TABS = [
// //   {
// //     label: "Home",
// //     path: "home",
// //     subtitle: "Welcome!",
// //     accentColor: "#FF6B00",
// //     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
// //     hasOwnAppBar: false,
// //   },
// //   {
// //     label: "Menu",
// //     path: "menu",
// //     subtitle: "Browse & order",
// //     accentColor: "#FF6B00",
// //     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
// //     hasOwnAppBar: true,
// //   },
// //   {
// //     label: "Offers",
// //     path: "offers",
// //     subtitle: "Deals & discounts",
// //     accentColor: "#FF6B00",
// //     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
// //     hasOwnAppBar: false,
// //   },
// //   {
// //     label: "Orders",
// //     path: "orders",
// //     subtitle: "Your order history",
// //     accentColor: "#FF6B00",
// //     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
// //     hasOwnAppBar: false,
// //   },
// //   {
// //     label: "Account",
// //     path: "account",
// //     subtitle: "Profile & settings",
// //     accentColor: "#FF6B00",
// //     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
// //     hasOwnAppBar: false,
// //   },
// // ];

// // const RestaurantLayout = () => {
// //   const { restaurantId } = useParams();
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const dispatch = useDispatch();
// //   const prevTabRef = useRef(0);
// //   const closeSubPageRef = useRef(null);

// //   // Redux states
// //   const restaurantInfo = useSelector(selectRestaurantInfo);
// //   const menuError = useSelector(selectMenuError);
// //   const menuLoading = useSelector(selectMenuLoading);

// //   // Payment Error Dialog State
// //   const [paymentErrorOpen, setPaymentErrorOpen] = useState(false);
// //   const [paymentErrorData, setPaymentErrorData] = useState(null);

// //   // Tracks AccountPage sub-pages
// //   const [subPage, setSubPage] = useState(null);
// //   const handleSubPageChange = useCallback((pageOrFalse, closeFn) => {
// //     setSubPage(pageOrFalse || null);
// //     if (closeFn) closeSubPageRef.current = closeFn;
// //     if (!pageOrFalse) closeSubPageRef.current = null;
// //   }, []);

// //   // Derive active tab from URL
// //   const lastSegment = location.pathname.split("/").pop();
// //   const tabIndex = TABS.findIndex((t) => t.path === lastSegment);
// //   const [activeTab, setActiveTab] = useState(tabIndex >= 0 ? tabIndex : 0);

// //   // Cart badge count
// //   const cartItems = useSelector((s) => s.cart?.items || []);
// //   const cartCount = cartItems.reduce((n, i) => n + (i.qty || 0), 0);

// //   // Offers badge count
// //   const allOffers = useSelector((s) => s.public?.offers || []);
// //   const offersCount = allOffers.length;

// //   useEffect(() => {
// //     if (restaurantId) {
// //       dispatch(resetMenuError());
// //       dispatch(fetchPublicMenu(restaurantId));
// //       dispatch(fetchPublicOffers(restaurantId));
// //     }

// //     return () => {
// //       dispatch(resetMenuError());
// //     };
// //   }, [restaurantId, dispatch]);

// //   useEffect(() => {
// //     if (menuError) {
// //       let status = null;
// //       let errorMessage = "This restaurant is currently unavailable.";
      
// //       if (menuError.data?.status) {
// //         status = menuError.data.status;
// //         errorMessage = menuError.message || menuError;
// //       } else if (menuError.status && typeof menuError.status === 'string') {
// //         status = menuError.status;
// //         errorMessage = menuError.message || menuError;
// //       } else if (menuError.success === false && menuError.data?.status) {
// //         status = menuError.data.status;
// //         errorMessage = menuError.message || menuError;
// //       }
      
// //       const paymentStatuses = ["EXPIRED", "INACTIVE", "PENDING", "PAYMENT_REQUIRED"];
// //       const isPaymentError = paymentStatuses.includes(status) || menuError?.status === 403;

// //       if (isPaymentError && status) {
// //         setPaymentErrorData({
// //           status: status,
// //           message: errorMessage,
// //           daysRemaining: menuError.data?.daysRemaining || null,
// //           canAccess: menuError.data?.canAccess || false,
// //         });
// //         setPaymentErrorOpen(true);
// //       }
// //     }
// //   }, [menuError]);

// //   const handleRetry = () => {
// //     setPaymentErrorOpen(false);
// //     setPaymentErrorData(null);
// //     dispatch(resetMenuError());
// //     if (restaurantId) {
// //       dispatch(fetchPublicMenu(restaurantId));
// //       dispatch(fetchPublicOffers(restaurantId));
// //     }
// //   };

// //   const handleTabChange = (_, newValue) => {
// //     prevTabRef.current = activeTab;
// //     setActiveTab(newValue);
// //     setSubPage(null);
// //     navigate(`/restaurant/${restaurantId}/${TABS[newValue].path}`);
// //   };

// //   useEffect(() => {
// //     const idx = TABS.findIndex((t) => t.path === lastSegment);
// //     if (idx >= 0 && idx !== activeTab) setActiveTab(idx);
// //   }, [location.pathname]);

// //   const handleBack = () => {
// //     if (subPage && closeSubPageRef.current) {
// //       closeSubPageRef.current();
// //       return;
// //     }
// //     navigate(-1);
// //   };

// //   const tab = TABS[activeTab];

// //   const SUB_PAGE_META = {
// //     help: {
// //       title: "Help & Support",
// //       subtitle: "FAQs, contact & tickets",
// //       gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
// //     },
// //     rate: {
// //       title: "Rate This Restaurant",
// //       subtitle: "Your feedback matters",
// //       gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
// //     },
// //     about: {
// //       title: "About",
// //       subtitle: "Version, team & legal",
// //       gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
// //     },
// //   };

// //   const subMeta = subPage ? SUB_PAGE_META[subPage] : null;

// //   const topTitle = subMeta
// //     ? subMeta.title
// //     : activeTab === 0
// //       ? restaurantInfo?.restaurantName || "Home"
// //       : tab.label;

// //   const topSubtitle = subMeta
// //     ? subMeta.subtitle
// //     : activeTab === 0
// //       ? restaurantInfo?.cuisine
// //         ? Array.isArray(restaurantInfo.cuisine)
// //           ? restaurantInfo.cuisine.join(" · ")
// //           : restaurantInfo.cuisine
// //         : "Welcome!"
// //       : tab.subtitle;

// //   const activeGradient = subMeta ? subMeta.gradient : tab.gradient;


// //   const renderPage = () => {
// //     if (paymentErrorOpen) {
// //       return null;
// //     }

// //     switch (activeTab) {
// //       case 0:
// //         return (
// //           <HomePage restaurantId={restaurantId} onTabChange={handleTabChange} />
// //         );
// //       case 1:
// //         return <PublicMenuPage restaurantId={restaurantId} />;
// //       case 2:
// //         return <OffersPage restaurantId={restaurantId} />;
// //       case 3:
// //         return <OrdersPage restaurantId={restaurantId} restaurantInfo={restaurantInfo} />;
// //       case 4:
// //         return (
// //           <AccountPage
// //             restaurantId={restaurantId}
// //             onSubPageChange={handleSubPageChange}
// //           />
// //         );
// //       default:
// //         return (
// //           <HomePage restaurantId={restaurantId} onTabChange={handleTabChange} />
// //         );
// //     }
// //   };

// //   if (paymentErrorOpen) {
// //     return (
// //       <PaymentErrorDialog
// //         open={paymentErrorOpen}
// //         errorData={paymentErrorData}
// //         onRetry={handleRetry}
// //       />
// //     );
// //   }

// //   return (
// //     <Box
// //       sx={{
// //         minHeight: "100vh",
// //         bgcolor: "#f5f5f5",
// //         display: "flex",
// //         flexDirection: "column",
// //       }}
// //     >
// //       {/* ══ STICKY TOP BAR ══ */}
// //       <Box
// //         sx={{
// //           position: "sticky",
// //           top: 0,
// //           zIndex: 1100,
// //           bgcolor: "white",
// //           boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
// //         }}
// //       >
// //         {/* Main row */}
// //         <Box
// //           sx={{
// //             display: "flex",
// //             alignItems: "center",
// //             px: 1.5,
// //             gap: 1.2,
// //             minHeight: 52,
// //           }}
// //         >
// //           <IconButton
// //             size="small"
// //             onClick={handleBack}
// //             sx={{
// //               width: 34,
// //               height: 34,
// //               bgcolor: "#f5f5f5",
// //               color: "#1a1a1a",
// //               flexShrink: 0,
// //               "&:hover": { bgcolor: "#ebebeb" },
// //               transition: "background 0.15s",
// //             }}
// //           >
// //             <ArrowBackIosNewIcon sx={{ fontSize: 15 }} />
// //           </IconButton>

// //           <Box sx={{ flex: 1, minWidth: 0 }}>
// //             <Typography
// //               sx={{
// //                 fontWeight: 800,
// //                 fontSize: "0.95rem",
// //                 color: "#1a1a1a",
// //                 lineHeight: 1.2,
// //                 whiteSpace: "nowrap",
// //                 overflow: "hidden",
// //                 textOverflow: "ellipsis",
// //               }}
// //             >
// //               {topTitle}
// //             </Typography>
// //             <Typography
// //               sx={{
// //                 fontSize: "0.68rem",
// //                 color: "#888",
// //                 lineHeight: 1,
// //                 display: "block",
// //               }}
// //             >
// //               {topSubtitle}
// //             </Typography>
// //           </Box>

// //           {activeTab === 3 && cartCount > 0 && (
// //             <Box
// //               sx={{
// //                 px: 1,
// //                 py: 0.35,
// //                 bgcolor: "#f3e5f5",
// //                 borderRadius: 2,
// //                 border: "1px solid #e1bee7",
// //                 flexShrink: 0,
// //               }}
// //             >
// //               <Typography
// //                 sx={{ fontWeight: 800, fontSize: "0.67rem", color: "#6a1b9a" }}
// //               >
// //                 {cartCount} in cart
// //               </Typography>
// //             </Box>
// //           )}
// //         </Box>

// //         <Box
// //           sx={{
// //             height: 3,
// //             background: activeGradient,
// //             transition: "background 0.3s ease",
// //           }}
// //         />
// //       </Box>

// //       {/* ══ PAGE CONTENT ════════════════════════════════════════════ */}
// //       <Box sx={{ flex: 1, pb: "56px" }}>{renderPage()}</Box>

// //       {/* ══ FIXED BOTTOM NAVIGATION ══ */}
// //       {!(activeTab === 4 && subPage) && (
// //         <Paper
// //           elevation={8}
// //           sx={{
// //             position: "fixed",
// //             bottom: 0,
// //             left: 0,
// //             right: 0,
// //             zIndex: 1200,
// //             borderTop: "1px solid #ebebeb",
// //             borderRadius: 0,
// //           }}
// //         >
// //           <BottomNavigation
// //             value={activeTab}
// //             onChange={handleTabChange}
// //             showLabels
// //             sx={{
// //               height: 56,
// //               bgcolor: "white",
// //               "& .MuiBottomNavigationAction-root": {
// //                 minWidth: 0,
// //                 px: 0.5,
// //                 fontSize: "0.65rem",
// //                 color: "#9e9e9e",
// //                 transition: "color 0.2s",
// //               },
// //               "& .Mui-selected": {
// //                 color: `${TABS[activeTab]?.accentColor || "#FF6B00"} !important`,
// //                 "& .MuiBottomNavigationAction-label": {
// //                   fontSize: "0.65rem !important",
// //                   fontWeight: 700,
// //                 },
// //               },
// //             }}
// //           >
// //             <BottomNavigationAction
// //               label="Home"
// //               icon={<HomeIcon sx={{ fontSize: 22 }} />}
// //             />

// //             <BottomNavigationAction
// //               label="Menu"
// //               icon={
// //                 <Badge
// //                   badgeContent={cartCount > 0 ? cartCount : null}
// //                   color="error"
// //                   sx={{
// //                     "& .MuiBadge-badge": {
// //                       fontSize: "0.6rem",
// //                       minWidth: 16,
// //                       height: 16,
// //                     },
// //                   }}
// //                 >
// //                   <RestaurantMenuIcon sx={{ fontSize: 22 }} />
// //                 </Badge>
// //               }
// //             />

// //             <BottomNavigationAction
// //               label="Offers"
// //               icon={
// //                 <Badge
// //                   badgeContent={offersCount > 0 ? offersCount : null}
// //                   color="success"
// //                   sx={{
// //                     "& .MuiBadge-badge": {
// //                       fontSize: "0.6rem",
// //                       minWidth: 16,
// //                       height: 16,
// //                     },
// //                   }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       width: 44,
// //                       height: 44,
// //                       borderRadius: "50%",
// //                       bgcolor: activeTab === 2 ? "#FF6B00" : "#fff",
// //                       display: "flex",
// //                       alignItems: "center",
// //                       justifyContent: "center",
// //                       mt: -1.5,
// //                       boxShadow:
// //                         activeTab === 2
// //                           ? "0 4px 12px rgba(255,107,0,0.45)"
// //                           : "0 2px 8px rgba(0,0,0,0.1)",
// //                       transition: "all 0.2s",
// //                       border: "2px solid white",
// //                     }}
// //                   >
// //                     <LocalOfferIcon
// //                       sx={{
// //                         fontSize: 20,
// //                         color: activeTab === 2 ? "white" : "#FF6B00",
// //                       }}
// //                     />
// //                   </Box>
// //                 </Badge>
// //               }
// //               sx={{ "& .MuiBottomNavigationAction-label": { mt: 0.5 } }}
// //             />

// //             <BottomNavigationAction
// //               label="Orders"
// //               icon={<ReceiptLongIcon sx={{ fontSize: 22 }} />}
// //             />

// //             <BottomNavigationAction
// //               label="Account"
// //               icon={<PersonOutlineIcon sx={{ fontSize: 22 }} />}
// //             />
// //           </BottomNavigation>
// //         </Paper>
// //       )}

// //       {/* Payment Error Dialog - Fallback */}
// //       <PaymentErrorDialog
// //         open={paymentErrorOpen}
// //         errorData={paymentErrorData}
// //         onRetry={handleRetry}
// //       />
// //     </Box>
// //   );
// // };

// // export default RestaurantLayout;
// import { useState, useEffect, useRef, useCallback } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import {
//   Box,
//   Paper,
//   BottomNavigation,
//   BottomNavigationAction,
//   Badge,
//   Typography,
//   IconButton,
//   Menu,
//   MenuItem,
//   ListItemIcon,
//   Divider,
//   Snackbar,
//   Alert,
//   Tooltip,
//   Button,
// } from "@mui/material";
// import HomeIcon from "@mui/icons-material/Home";
// import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import ClearAllIcon from "@mui/icons-material/ClearAll";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   fetchPublicMenu,
//   fetchPublicOffers,
//   selectRestaurantInfo,
//   selectMenuError,
//   selectMenuLoading,
//   resetMenuError,
// } from "../../redux/slices/publicSlice";
// import { useSocket } from "../../context/SocketContext";
// import PaymentErrorDialog from "./PaymentErrorDialog";

// // Import all tab pages
// import HomePage from "./tabs/HomePage";
// import PublicMenuPage from "./tabs/PublicMenuPage";
// import OffersPage from "./tabs/OffersPage";
// import OrdersPage from "./tabs/OrdersPage";
// import AccountPage from "./tabs/AccountPage";

// // ── Tab config ────────────────────────────────────
// const TABS = [
//   {
//     label: "Home",
//     path: "home",
//     subtitle: "Welcome!",
//     accentColor: "#FF6B00",
//     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
//     hasOwnAppBar: false,
//   },
//   {
//     label: "Menu",
//     path: "menu",
//     subtitle: "Browse & order",
//     accentColor: "#FF6B00",
//     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
//     hasOwnAppBar: true,
//   },
//   {
//     label: "Offers",
//     path: "offers",
//     subtitle: "Deals & discounts",
//     accentColor: "#FF6B00",
//     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
//     hasOwnAppBar: false,
//   },
//   {
//     label: "Orders",
//     path: "orders",
//     subtitle: "Your order history",
//     accentColor: "#FF6B00",
//     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
//     hasOwnAppBar: false,
//   },
//   {
//     label: "Account",
//     path: "account",
//     subtitle: "Profile & settings",
//     accentColor: "#FF6B00",
//     gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
//     hasOwnAppBar: false,
//   },
// ];

// const RestaurantLayout = () => {
//   const { restaurantId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const prevTabRef = useRef(0);
//   const closeSubPageRef = useRef(null);
//   const { socket } = useSocket();

//   // ── Audio refs ────────────────────────────────────
//   const audioRef = useRef(null);
//   const audioUnlockedRef = useRef(false);

//   // Redux states
//   const restaurantInfo = useSelector(selectRestaurantInfo);
//   const menuError = useSelector(selectMenuError);
//   const menuLoading = useSelector(selectMenuLoading);

//   // Payment Error Dialog State
//   const [paymentErrorOpen, setPaymentErrorOpen] = useState(false);
//   const [paymentErrorData, setPaymentErrorData] = useState(null);

//   // Identifier (Slug ya ObjectId)
//   const effectiveKey = restaurantInfo?.slug || restaurantId || "default";
//   const storageKey = `rw_customer_notifs_${effectiveKey}`;

//   // State initialization directly from localStorage
//   const [notifications, setNotifications] = useState(() => {
//     try {
//       const saved = localStorage.getItem(`rw_customer_notifs_${restaurantId}`);
//       return saved ? JSON.parse(saved) : [];
//     } catch {
//       return [];
//     }
//   });

//   const isLoadedRef = useRef(false);
//   const lastProcessedEventRef = useRef("");

//   const [hasUnread, setHasUnread] = useState(false);
//   const [notifAnchorEl, setNotifAnchorEl] = useState(null);
//   const isNotifOpen = Boolean(notifAnchorEl);

//   const [toastAlert, setToastAlert] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });

//   // =========================================================
//   // 🎧 AUDIO SETUP + UNLOCK (Browser Autoplay Policy Fix)
//   // =========================================================
//   useEffect(() => {
//     // Create audio element
//     const audio = new Audio("/sounds/notification.mp3");
//     audio.preload = "auto";
//     audio.volume = 0.8;
//     audioRef.current = audio;

//     // Log load errors
//     audio.addEventListener("error", (e) => {
//       console.error("❌ Notification sound failed to load. Check /public/sounds/notification.mp3", e);
//     });

//     audio.addEventListener("canplaythrough", () => {
//       console.log("✅ Notification sound loaded successfully");
//     });

//     // 🔓 Unlock audio on first user gesture
//     const unlockAudio = () => {
//       if (audioUnlockedRef.current) return;

//       audio.muted = true;
//       const playPromise = audio.play();

//       if (playPromise !== undefined) {
//         playPromise
//           .then(() => {
//             audio.pause();
//             audio.currentTime = 0;
//             audio.muted = false;
//             audioUnlockedRef.current = true;
//             console.log("🔓 Notification audio unlocked");

//             // Remove listeners after successful unlock
//             document.removeEventListener("click", unlockAudio);
//             document.removeEventListener("touchstart", unlockAudio);
//             document.removeEventListener("keydown", unlockAudio);
//           })
//           .catch((err) => {
//             console.warn("⚠️ Audio unlock attempt failed:", err);
//           });
//       }
//     };

//     document.addEventListener("click", unlockAudio);
//     document.addEventListener("touchstart", unlockAudio);
//     document.addEventListener("keydown", unlockAudio);

//     return () => {
//       document.removeEventListener("click", unlockAudio);
//       document.removeEventListener("touchstart", unlockAudio);
//       document.removeEventListener("keydown", unlockAudio);
//       if (audioRef.current) {
//         audioRef.current.pause();
//         audioRef.current = null;
//       }
//     };
//   }, []);

//   // ── Robust play function ──
//   const playNotificationSound = useCallback(async () => {
//     try {
//       const audio = audioRef.current;
//       if (!audio) {
//         console.warn("⚠️ Audio ref not ready");
//         return;
//       }

//       // Agar abhi tak unlock nahi hua to try karo
//       if (!audioUnlockedRef.current) {
//         audio.muted = true;
//         try {
//           await audio.play();
//           audio.pause();
//           audio.currentTime = 0;
//           audio.muted = false;
//           audioUnlockedRef.current = true;
//           console.log("🔓 Audio auto-unlocked");
//         } catch (e) {
//           console.warn("⚠️ Audio still blocked. User interaction required.");
//           return;
//         }
//       }

//       // Reset + play
//       audio.muted = false;
//       audio.currentTime = 0;
//       audio.volume = 0.8;

//       const playPromise = audio.play();
//       if (playPromise !== undefined) {
//         playPromise
//           .then(() => {
//             console.log("🔔 Notification sound played");
//           })
//           .catch((err) => {
//             console.warn("❌ Play failed:", err.name, err.message);
//           });
//       }
//     } catch (e) {
//       console.warn("Audio error:", e);
//     }
//   }, []);

//   // Restaurant change ya load hone par sahi key se load karein
//   useEffect(() => {
//     try {
//       const saved =
//         localStorage.getItem(`rw_customer_notifs_${restaurantInfo?.slug}`) ||
//         localStorage.getItem(`rw_customer_notifs_${restaurantInfo?._id}`) ||
//         localStorage.getItem(`rw_customer_notifs_${restaurantId}`);

//       if (saved) {
//         setNotifications(JSON.parse(saved));
//       }
//     } catch (e) {
//       console.error("Storage load error:", e);
//     } finally {
//       isLoadedRef.current = true;
//     }
//   }, [restaurantInfo?.slug, restaurantInfo?._id, restaurantId]);

//   // Notifications change hone par localStorage me save karein
//   useEffect(() => {
//     if (!isLoadedRef.current) return;
//     try {
//       localStorage.setItem(storageKey, JSON.stringify(notifications));
//       if (restaurantInfo?._id) {
//         localStorage.setItem(
//           `rw_customer_notifs_${restaurantInfo._id}`,
//           JSON.stringify(notifications)
//         );
//       }
//       if (restaurantInfo?.slug) {
//         localStorage.setItem(
//           `rw_customer_notifs_${restaurantInfo.slug}`,
//           JSON.stringify(notifications)
//         );
//       }
//     } catch (e) {
//       console.error("Failed to save notifications to storage:", e);
//     }
//   }, [notifications, storageKey, restaurantInfo]);

//   // Tracks AccountPage sub-pages
//   const [subPage, setSubPage] = useState(null);
//   const handleSubPageChange = useCallback((pageOrFalse, closeFn) => {
//     setSubPage(pageOrFalse || null);
//     if (closeFn) closeSubPageRef.current = closeFn;
//     if (!pageOrFalse) closeSubPageRef.current = null;
//   }, []);

//   const lastSegment = location.pathname.split("/").pop();
//   const tabIndex = TABS.findIndex((t) => t.path === lastSegment);
//   const [activeTab, setActiveTab] = useState(tabIndex >= 0 ? tabIndex : 0);

//   const cartItems = useSelector((s) => s.cart?.items || []);
//   const cartCount = cartItems.reduce((n, i) => n + (i.qty || 0), 0);

//   const allOffers = useSelector((s) => s.public?.offers || []);
//   const offersCount = allOffers.length;

//   useEffect(() => {
//     if (restaurantId) {
//       dispatch(resetMenuError());
//       dispatch(fetchPublicMenu(restaurantId));
//       dispatch(fetchPublicOffers(restaurantId));
//     }
//     return () => {
//       dispatch(resetMenuError());
//     };
//   }, [restaurantId, dispatch]);

//   useEffect(() => {
//     if (menuError) {
//       let status = null;
//       let errorMessage = "This restaurant is currently unavailable.";

//       if (menuError.data?.status) {
//         status = menuError.data.status;
//         errorMessage = menuError.message || menuError;
//       } else if (menuError.status && typeof menuError.status === "string") {
//         status = menuError.status;
//         errorMessage = menuError.message || menuError;
//       } else if (menuError.success === false && menuError.data?.status) {
//         status = menuError.data.status;
//         errorMessage = menuError.message || menuError;
//       }

//       const paymentStatuses = ["EXPIRED", "INACTIVE", "PENDING", "PAYMENT_REQUIRED"];
//       const isPaymentError =
//         paymentStatuses.includes(status) || menuError?.status === 403;

//       if (isPaymentError && status) {
//         setPaymentErrorData({
//           status: status,
//           message: errorMessage,
//           daysRemaining: menuError.data?.daysRemaining || null,
//           canAccess: menuError.data?.canAccess || false,
//         });
//         setPaymentErrorOpen(true);
//       }
//     }
//   }, [menuError]);

//   // =========================================================
//   // ⚡ REAL-TIME SOCKET STATUS LISTENER (With Duplicate Prevention)
//   // =========================================================
//   useEffect(() => {
//     if (!socket) return;

//     const handleOrderStatusUpdate = (data) => {
//       const order = data.order || data;
//       const status = data.status || order.status;
//       const orderId = (order._id || data.orderId || "").toString();
//       const shortId = orderId.slice(-6).toUpperCase();

//       // Duplicate Event Prevention (1 sec ke andar same status ignore)
//       const eventKey = `${orderId}_${status}`;
//       if (lastProcessedEventRef.current === eventKey) return;
//       lastProcessedEventRef.current = eventKey;
//       setTimeout(() => {
//         if (lastProcessedEventRef.current === eventKey) {
//           lastProcessedEventRef.current = "";
//         }
//       }, 1500);

//       const labels = {
//         ACCEPTED: "Order Accepted 👍",
//         PREPARING: "Kitchen is preparing your food 🍳",
//         COMPLETED: "Your order is ready! 🎉",
//         DELIVERED: "Order delivered! 😋",
//         CANCELLED: "Order cancelled ❌",
//       };

//       const msg = `Order #${shortId}: ${
//         labels[status] || `Status updated to ${status}`
//       }`;

//       // 🔊 Play notification sound
//       playNotificationSound();

//       setToastAlert({
//         open: true,
//         message: msg,
//         severity: status === "CANCELLED" ? "error" : "success",
//       });

//       setNotifications((prev) => {
//         const isDuplicate = prev.some(
//           (n) =>
//             n.orderId === orderId &&
//             n.status === status &&
//             Date.now() - n.id < 5000
//         );
//         if (isDuplicate) return prev;

//         return [
//           {
//             id: Date.now(),
//             orderId: orderId,
//             text: msg,
//             status,
//             time: new Date().toLocaleTimeString([], {
//               hour: "2-digit",
//               minute: "2-digit",
//             }),
//           },
//           ...prev,
//         ];
//       });

//       setHasUnread(true);
//     };

//     socket.on("order-status-updated", handleOrderStatusUpdate);

//     return () => {
//       socket.off("order-status-updated", handleOrderStatusUpdate);
//     };
//   }, [socket, playNotificationSound]);

//   const handleRetry = () => {
//     setPaymentErrorOpen(false);
//     setPaymentErrorData(null);
//     dispatch(resetMenuError());
//     if (restaurantId) {
//       dispatch(fetchPublicMenu(restaurantId));
//       dispatch(fetchPublicOffers(restaurantId));
//     }
//   };

//   const handleTabChange = (_, newValue) => {
//     prevTabRef.current = activeTab;
//     setActiveTab(newValue);
//     setSubPage(null);
//     const identifier = restaurantInfo?.slug || restaurantId;
//     navigate(`/restaurant/${identifier}/${TABS[newValue].path}`);
//   };

//   const handleTopBarCartClick = () => {
//     const identifier = restaurantInfo?.slug || restaurantId;
//     if (activeTab !== 1) {
//       navigate(`/restaurant/${identifier}/menu`);
//       setActiveTab(1);
//     }
//     window.dispatchEvent(new CustomEvent("open-cart-drawer"));
//   };

//   // Delete single notification
//   const handleDeleteNotification = (e, notifId) => {
//     e.stopPropagation();
//     setNotifications((prev) => {
//       const updated = prev.filter((item) => item.id !== notifId);
//       try {
//         localStorage.setItem(storageKey, JSON.stringify(updated));
//       } catch (err) {}
//       return updated;
//     });
//   };

//   // Clear all notifications
//   const handleClearAllNotifications = () => {
//     setNotifications([]);
//     setHasUnread(false);
//     setNotifAnchorEl(null);
//     try {
//       localStorage.removeItem(storageKey);
//       if (restaurantInfo?._id)
//         localStorage.removeItem(`rw_customer_notifs_${restaurantInfo._id}`);
//       if (restaurantInfo?.slug)
//         localStorage.removeItem(`rw_customer_notifs_${restaurantInfo.slug}`);
//     } catch (err) {}
//   };

//   useEffect(() => {
//     const idx = TABS.findIndex((t) => t.path === lastSegment);
//     if (idx >= 0 && idx !== activeTab) setActiveTab(idx);
//   }, [location.pathname]);

//   const handleBack = () => {
//     if (subPage && closeSubPageRef.current) {
//       closeSubPageRef.current();
//       return;
//     }
//     navigate(-1);
//   };

//   const tab = TABS[activeTab] || TABS[0];

//   const SUB_PAGE_META = {
//     help: {
//       title: "Help & Support",
//       subtitle: "FAQs, contact & tickets",
//       gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
//     },
//     rate: {
//       title: "Rate This Restaurant",
//       subtitle: "Your feedback matters",
//       gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
//     },
//     about: {
//       title: "About",
//       subtitle: "Version, team & legal",
//       gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
//     },
//   };

//   const subMeta = subPage ? SUB_PAGE_META[subPage] : null;

//   const topTitle = subMeta
//     ? subMeta.title
//     : activeTab === 0
//     ? restaurantInfo?.restaurantName || "Home"
//     : tab.label;

//   const topSubtitle = subMeta
//     ? subMeta.subtitle
//     : activeTab === 0
//     ? restaurantInfo?.cuisine
//       ? Array.isArray(restaurantInfo.cuisine)
//         ? restaurantInfo.cuisine.join(" · ")
//         : restaurantInfo.cuisine
//       : "Welcome!"
//     : tab.subtitle;

//   const activeGradient = subMeta ? subMeta.gradient : tab.gradient;

//   const renderPage = () => {
//     if (paymentErrorOpen) return null;

//     switch (activeTab) {
//       case 0:
//         return (
//           <HomePage
//             restaurantId={restaurantId}
//             onTabChange={handleTabChange}
//           />
//         );
//       case 1:
//         return <PublicMenuPage restaurantId={restaurantId} />;
//       case 2:
//         return <OffersPage restaurantId={restaurantId} />;
//       case 3:
//         return (
//           <OrdersPage
//             restaurantId={restaurantId}
//             restaurantInfo={restaurantInfo}
//           />
//         );
//       case 4:
//         return (
//           <AccountPage
//             restaurantId={restaurantId}
//             onSubPageChange={handleSubPageChange}
//           />
//         );
//       default:
//         return (
//           <HomePage
//             restaurantId={restaurantId}
//             onTabChange={handleTabChange}
//           />
//         );
//     }
//   };

//   if (paymentErrorOpen) {
//     return (
//       <PaymentErrorDialog
//         open={paymentErrorOpen}
//         errorData={paymentErrorData}
//         onRetry={handleRetry}
//       />
//     );
//   }

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         bgcolor: "#f5f5f5",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       {/* ══ STICKY TOP BAR ══ */}
//       <Box
//         sx={{
//           position: "sticky",
//           top: 0,
//           zIndex: 1100,
//           bgcolor: "white",
//           boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             px: { xs: 1.2, sm: 2 },
//             gap: 1,
//             minHeight: 54,
//           }}
//         >
//           <IconButton
//             size="small"
//             onClick={handleBack}
//             sx={{
//               width: 34,
//               height: 34,
//               bgcolor: "#f5f5f5",
//               color: "#1a1a1a",
//               flexShrink: 0,
//               "&:hover": { bgcolor: "#ebebeb" },
//               transition: "background 0.15s",
//             }}
//           >
//             <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
//           </IconButton>

//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "0.9rem", sm: "1rem" },
//                 color: "#1a1a1a",
//                 lineHeight: 1.2,
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               {topTitle}
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.68rem",
//                 color: "#888",
//                 lineHeight: 1,
//                 display: "block",
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               {topSubtitle}
//             </Typography>
//           </Box>

//           {/* 🔔 Right Side Icons */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 0.8,
//               flexShrink: 0,
//             }}
//           >
//             {/* Notification Bell */}
//             <IconButton
//               size="small"
//               onClick={(e) => {
//                 setNotifAnchorEl(e.currentTarget);
//                 setHasUnread(false);
//               }}
//               sx={{
//                 width: 36,
//                 height: 36,
//                 bgcolor: "#f5f5f5",
//                 color: "#444",
//                 "&:hover": { bgcolor: "#ebebeb" },
//               }}
//             >
//               <Badge
//                 color="error"
//                 variant="dot"
//                 invisible={!hasUnread && notifications.length === 0}
//               >
//                 <NotificationsIcon sx={{ fontSize: 20 }} />
//               </Badge>
//             </IconButton>

//             {/* Cart Icon */}
//             <IconButton
//               size="small"
//               onClick={handleTopBarCartClick}
//               sx={{
//                 width: 36,
//                 height: 36,
//                 bgcolor: "rgba(255, 107, 0, 0.1)",
//                 color: "#FF6B00",
//                 "&:hover": { bgcolor: "rgba(255, 107, 0, 0.18)" },
//               }}
//             >
//               <Badge
//                 badgeContent={cartCount > 0 ? cartCount : null}
//                 color="error"
//                 sx={{
//                   "& .MuiBadge-badge": {
//                     fontSize: "0.62rem",
//                     height: 16,
//                     minWidth: 16,
//                     px: 0.4,
//                   },
//                 }}
//               >
//                 <ShoppingCartIcon sx={{ fontSize: 20 }} />
//               </Badge>
//             </IconButton>
//           </Box>
//         </Box>

//         <Box
//           sx={{
//             height: 3,
//             background: activeGradient,
//             transition: "background 0.3s ease",
//           }}
//         />
//       </Box>

//       {/* ══ RESPONSIVE NOTIFICATION DROPDOWN MENU ══ */}
//       <Menu
//         anchorEl={notifAnchorEl}
//         open={isNotifOpen}
//         onClose={() => setNotifAnchorEl(null)}
//         PaperProps={{
//           sx: {
//             width: { xs: "92vw", sm: 360 },
//             maxWidth: 380,
//             borderRadius: 3,
//             boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
//             border: "1px solid #ebebeb",
//           },
//         }}
//         transformOrigin={{ horizontal: "right", vertical: "top" }}
//         anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             px: 2,
//             py: 1.2,
//           }}
//         >
//           <Typography
//             variant="subtitle2"
//             sx={{ fontWeight: 800, fontSize: "0.88rem" }}
//           >
//             Order Notifications ({notifications.length})
//           </Typography>
//           {notifications.length > 0 && (
//             <Button
//               size="small"
//               onClick={handleClearAllNotifications}
//               startIcon={<ClearAllIcon sx={{ fontSize: 16 }} />}
//               sx={{
//                 textTransform: "none",
//                 fontSize: "0.7rem",
//                 color: "#f44336",
//                 fontWeight: 700,
//                 py: 0.2,
//               }}
//             >
//               Clear All
//             </Button>
//           )}
//         </Box>
//         <Divider />

//         {/* 📜 Notifications Display with Clean Scrollbar */}
//         <Box
//           sx={{
//             maxHeight: 290,
//             overflowY: "auto",
//             "&::-webkit-scrollbar": { width: 5 },
//             "&::-webkit-scrollbar-thumb": {
//               bgcolor: "#d6d6d6",
//               borderRadius: 3,
//             },
//           }}
//         >
//           {notifications.length === 0 ? (
//             <Box sx={{ p: 4, textAlign: "center" }}>
//               <Typography
//                 variant="body2"
//                 sx={{ color: "#888", fontSize: "0.82rem" }}
//               >
//                 No active notifications
//               </Typography>
//             </Box>
//           ) : (
//             notifications.map((n) => (
//               <MenuItem
//                 key={n.id}
//                 onClick={() => {
//                   setNotifAnchorEl(null);
//                   handleTabChange(null, 3); // Go to Orders Tab
//                 }}
//                 sx={{
//                   py: 1.2,
//                   px: 1.8,
//                   display: "flex",
//                   alignItems: "flex-start",
//                   gap: 1.2,
//                   borderBottom: "1px solid #f2f2f2",
//                   "&:hover": { bgcolor: "#fff8f3" },
//                 }}
//               >
//                 <ListItemIcon sx={{ minWidth: 26, mt: 0.3 }}>
//                   <CheckCircleIcon sx={{ fontSize: 18, color: "#2e7d32" }} />
//                 </ListItemIcon>

//                 <Box sx={{ flex: 1, minWidth: 0 }}>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontWeight: 600,
//                       fontSize: "0.8rem",
//                       color: "#1a1a1a",
//                       whiteSpace: "normal",
//                       wordBreak: "break-word",
//                       lineHeight: 1.35,
//                     }}
//                   >
//                     {n.text}
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: "#999",
//                       fontSize: "0.68rem",
//                       mt: 0.3,
//                       display: "block",
//                     }}
//                   >
//                     {n.time}
//                   </Typography>
//                 </Box>

//                 <Tooltip title="Delete">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => handleDeleteNotification(e, n.id)}
//                     sx={{
//                       p: 0.5,
//                       color: "#aaa",
//                       flexShrink: 0,
//                       "&:hover": { color: "#f44336", bgcolor: "#ffebee" },
//                     }}
//                   >
//                     <DeleteOutlineIcon sx={{ fontSize: 16 }} />
//                   </IconButton>
//                 </Tooltip>
//               </MenuItem>
//             ))
//           )}
//         </Box>
//       </Menu>

//       {/* ══ PAGE CONTENT ════════════════════════════════════════════ */}
//       <Box sx={{ flex: 1, pb: "56px" }}>{renderPage()}</Box>

//       {/* ══ FIXED BOTTOM NAVIGATION ══ */}
//       {!(activeTab === 4 && subPage) && (
//         <Paper
//           elevation={8}
//           sx={{
//             position: "fixed",
//             bottom: 0,
//             left: 0,
//             right: 0,
//             zIndex: 1200,
//             borderTop: "1px solid #ebebeb",
//             borderRadius: 0,
//           }}
//         >
//           <BottomNavigation
//             value={activeTab}
//             onChange={handleTabChange}
//             showLabels
//             sx={{
//               height: 56,
//               bgcolor: "white",
//               "& .MuiBottomNavigationAction-root": {
//                 minWidth: 0,
//                 px: 0.5,
//                 fontSize: "0.65rem",
//                 color: "#9e9e9e",
//                 transition: "color 0.2s",
//               },
//               "& .Mui-selected": {
//                 color: `${TABS[activeTab]?.accentColor || "#FF6B00"} !important`,
//                 "& .MuiBottomNavigationAction-label": {
//                   fontSize: "0.65rem !important",
//                   fontWeight: 700,
//                 },
//               },
//             }}
//           >
//             <BottomNavigationAction
//               label="Home"
//               icon={<HomeIcon sx={{ fontSize: 22 }} />}
//             />
//             <BottomNavigationAction
//               label="Menu"
//               icon={
//                 <Badge
//                   badgeContent={cartCount > 0 ? cartCount : null}
//                   color="error"
//                   sx={{
//                     "& .MuiBadge-badge": {
//                       fontSize: "0.6rem",
//                       minWidth: 16,
//                       height: 16,
//                     },
//                   }}
//                 >
//                   <RestaurantMenuIcon sx={{ fontSize: 22 }} />
//                 </Badge>
//               }
//             />
//             <BottomNavigationAction
//               label="Offers"
//               icon={
//                 <Badge
//                   badgeContent={offersCount > 0 ? offersCount : null}
//                   color="success"
//                   sx={{
//                     "& .MuiBadge-badge": {
//                       fontSize: "0.6rem",
//                       minWidth: 16,
//                       height: 16,
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 44,
//                       height: 44,
//                       borderRadius: "50%",
//                       bgcolor: activeTab === 2 ? "#FF6B00" : "#fff",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       mt: -1.5,
//                       boxShadow:
//                         activeTab === 2
//                           ? "0 4px 12px rgba(255,107,0,0.45)"
//                           : "0 2px 8px rgba(0,0,0,0.1)",
//                       transition: "all 0.2s",
//                       border: "2px solid white",
//                     }}
//                   >
//                     <LocalOfferIcon
//                       sx={{
//                         fontSize: 20,
//                         color: activeTab === 2 ? "white" : "#FF6B00",
//                       }}
//                     />
//                   </Box>
//                 </Badge>
//               }
//               sx={{ "& .MuiBottomNavigationAction-label": { mt: 0.5 } }}
//             />
//             <BottomNavigationAction
//               label="Orders"
//               icon={<ReceiptLongIcon sx={{ fontSize: 22 }} />}
//             />
//             <BottomNavigationAction
//               label="Account"
//               icon={<PersonOutlineIcon sx={{ fontSize: 22 }} />}
//             />
//           </BottomNavigation>
//         </Paper>
//       )}

//       {/* ══ REAL-TIME ORDER UPDATE TOAST ══ */}
//       <Snackbar
//         open={toastAlert.open}
//         autoHideDuration={4500}
//         onClose={() => setToastAlert((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           severity={toastAlert.severity}
//           variant="filled"
//           onClose={() => setToastAlert((prev) => ({ ...prev, open: false }))}
//           sx={{
//             borderRadius: 3,
//             fontWeight: 700,
//             fontSize: "0.82rem",
//             boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
//             cursor: "pointer",
//           }}
//           onClick={() => {
//             setToastAlert((prev) => ({ ...prev, open: false }));
//             handleTabChange(null, 3);
//           }}
//         >
//           {toastAlert.message}
//         </Alert>
//       </Snackbar>

//       {/* Payment Error Dialog - Fallback */}
//       <PaymentErrorDialog
//         open={paymentErrorOpen}
//         errorData={paymentErrorData}
//         onRetry={handleRetry}
//       />
//     </Box>
//   );
// };

// export default RestaurantLayout;


// import { useState, useEffect, useRef, useCallback } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import {
//   Box, Paper, BottomNavigation, BottomNavigationAction, Badge,
//   Typography, IconButton, Menu, MenuItem, ListItemIcon, Divider,
//   Snackbar, Alert, Tooltip, Button,
// } from "@mui/material";
// import HomeIcon from "@mui/icons-material/Home";
// import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import ClearAllIcon from "@mui/icons-material/ClearAll";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   fetchPublicMenu, fetchPublicOffers, selectRestaurantInfo,
//   selectMenuError, resetMenuError,
// } from "../../redux/slices/publicSlice";
// import { useSocket } from "../../context/SocketContext";
// import { useMyOrders } from "../../hooks/useMyOrders"; // 🔥 Naya hook
// import PaymentErrorDialog from "./PaymentErrorDialog";

// import HomePage from "./tabs/HomePage";
// import PublicMenuPage from "./tabs/PublicMenuPage";
// import OffersPage from "./tabs/OffersPage";
// import OrdersPage from "./tabs/OrdersPage";
// import AccountPage from "./tabs/AccountPage";

// // ── Tab config ────────────────────────────────────
// const TABS = [
//   { label: "Home", path: "home", subtitle: "Welcome!", accentColor: "#FF6B00", gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)" },
//   { label: "Menu", path: "menu", subtitle: "Browse & order", accentColor: "#FF6B00", gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)" },
//   { label: "Offers", path: "offers", subtitle: "Deals & discounts", accentColor: "#FF6B00", gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)" },
//   { label: "Orders", path: "orders", subtitle: "Your order history", accentColor: "#FF6B00", gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)" },
//   { label: "Account", path: "account", subtitle: "Profile & settings", accentColor: "#FF6B00", gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)" },
// ];

// // ── Global audio instance ─────────────────────────
// let globalAudio = null;
// let globalAudioUnlocked = false;

// const getGlobalAudio = () => {
//   if (!globalAudio) {
//     globalAudio = new Audio("/sounds/notification.mp3");
//     globalAudio.preload = "auto";
//     globalAudio.volume = 0.8;
//     globalAudio.addEventListener("error", () => {
//       console.error("❌ Sound file missing: /public/sounds/notification.mp3");
//     });
//     globalAudio.addEventListener("canplaythrough", () => {
//       console.log("✅ Sound loaded");
//     });
//   }
//   return globalAudio;
// };

// const RestaurantLayout = () => {
//   const { restaurantId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const prevTabRef = useRef(0);
//   const closeSubPageRef = useRef(null);
//   const { socket } = useSocket();

//   // 🔥 Layout-level orders fetch — HAR PAGE PE
//   const { getMyOrders } = useMyOrders();

//   const restaurantInfo = useSelector(selectRestaurantInfo);
//   const menuError = useSelector(selectMenuError);

//   const [paymentErrorOpen, setPaymentErrorOpen] = useState(false);
//   const [paymentErrorData, setPaymentErrorData] = useState(null);

//   const effectiveKey = restaurantInfo?.slug || restaurantId || "default";
//   const storageKey = `rw_customer_notifs_${effectiveKey}`;

//   const [notifications, setNotifications] = useState(() => {
//     try {
//       const saved = localStorage.getItem(`rw_customer_notifs_${restaurantId}`);
//       return saved ? JSON.parse(saved) : [];
//     } catch { return []; }
//   });

//   const isLoadedRef = useRef(false);
//   const lastProcessedEventRef = useRef("");

//   const [hasUnread, setHasUnread] = useState(false);
//   const [notifAnchorEl, setNotifAnchorEl] = useState(null);
//   const isNotifOpen = Boolean(notifAnchorEl);

//   const [toastAlert, setToastAlert] = useState({
//     open: false, message: "", severity: "info",
//   });

//   // =========================================================
//   // 🔥 CRITICAL FIX: Fetch orders at LAYOUT level (not OrdersPage)
//   // Isse socket rooms har page pe join ho jayenge
//   // =========================================================
//   useEffect(() => {
//     if (restaurantId) {
//       console.log("🔄 Layout: Fetching my orders for socket room join");
//       getMyOrders();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [restaurantId]);

//   // =========================================================
//   // 🎧 AUDIO SETUP
//   // =========================================================
//   useEffect(() => {
//     const audio = getGlobalAudio();

//     const unlockAudio = () => {
//       if (globalAudioUnlocked) return;
//       audio.muted = true;
//       const p = audio.play();
//       if (p !== undefined) {
//         p.then(() => {
//           audio.pause();
//           audio.currentTime = 0;
//           audio.muted = false;
//           globalAudioUnlocked = true;
//           console.log("🔓 Audio unlocked");
//           document.removeEventListener("click", unlockAudio);
//           document.removeEventListener("touchstart", unlockAudio);
//           document.removeEventListener("keydown", unlockAudio);
//         }).catch((err) => console.warn("⚠️ Unlock failed:", err));
//       }
//     };

//     document.addEventListener("click", unlockAudio);
//     document.addEventListener("touchstart", unlockAudio);
//     document.addEventListener("keydown", unlockAudio);

//     return () => {
//       document.removeEventListener("click", unlockAudio);
//       document.removeEventListener("touchstart", unlockAudio);
//       document.removeEventListener("keydown", unlockAudio);
//     };
//   }, []);

//   const playNotificationSound = useCallback(async () => {
//     try {
//       const audio = getGlobalAudio();
//       if (!globalAudioUnlocked) {
//         audio.muted = true;
//         try {
//           await audio.play();
//           audio.pause();
//           audio.currentTime = 0;
//           audio.muted = false;
//           globalAudioUnlocked = true;
//         } catch (e) {
//           console.warn("⚠️ Audio blocked");
//           return;
//         }
//       }
//       audio.muted = false;
//       audio.currentTime = 0;
//       audio.volume = 0.8;
//       const p = audio.play();
//       if (p !== undefined) {
//         p.then(() => console.log("🔔 Sound played"))
//          .catch((err) => console.warn("❌ Play failed:", err.name));
//       }
//     } catch (e) {
//       console.warn("Audio error:", e);
//     }
//   }, []);

//   // Load/Save notifications
//   useEffect(() => {
//     try {
//       const saved =
//         localStorage.getItem(`rw_customer_notifs_${restaurantInfo?.slug}`) ||
//         localStorage.getItem(`rw_customer_notifs_${restaurantInfo?._id}`) ||
//         localStorage.getItem(`rw_customer_notifs_${restaurantId}`);
//       if (saved) setNotifications(JSON.parse(saved));
//     } catch (e) {
//       console.error("Storage load error:", e);
//     } finally {
//       isLoadedRef.current = true;
//     }
//   }, [restaurantInfo?.slug, restaurantInfo?._id, restaurantId]);

//   useEffect(() => {
//     if (!isLoadedRef.current) return;
//     try {
//       localStorage.setItem(storageKey, JSON.stringify(notifications));
//       if (restaurantInfo?._id)
//         localStorage.setItem(`rw_customer_notifs_${restaurantInfo._id}`, JSON.stringify(notifications));
//       if (restaurantInfo?.slug)
//         localStorage.setItem(`rw_customer_notifs_${restaurantInfo.slug}`, JSON.stringify(notifications));
//     } catch (e) {
//       console.error("Save error:", e);
//     }
//   }, [notifications, storageKey, restaurantInfo]);

//   const [subPage, setSubPage] = useState(null);
//   const handleSubPageChange = useCallback((pageOrFalse, closeFn) => {
//     setSubPage(pageOrFalse || null);
//     if (closeFn) closeSubPageRef.current = closeFn;
//     if (!pageOrFalse) closeSubPageRef.current = null;
//   }, []);

//   const lastSegment = location.pathname.split("/").pop();
//   const tabIndex = TABS.findIndex((t) => t.path === lastSegment);
//   const [activeTab, setActiveTab] = useState(tabIndex >= 0 ? tabIndex : 0);

//   const cartItems = useSelector((s) => s.cart?.items || []);
//   const cartCount = cartItems.reduce((n, i) => n + (i.qty || i.quantity || 0), 0);

//   const allOffers = useSelector((s) => s.public?.offers || []);
//   const offersCount = allOffers.length;

//   useEffect(() => {
//     if (restaurantId) {
//       dispatch(resetMenuError());
//       dispatch(fetchPublicMenu(restaurantId));
//       dispatch(fetchPublicOffers(restaurantId));
//     }
//     return () => { dispatch(resetMenuError()); };
//   }, [restaurantId, dispatch]);

//   useEffect(() => {
//     if (menuError) {
//       let status = null;
//       let errorMessage = "This restaurant is currently unavailable.";
//       if (menuError.data?.status) {
//         status = menuError.data.status;
//         errorMessage = menuError.message || menuError;
//       } else if (menuError.status && typeof menuError.status === "string") {
//         status = menuError.status;
//         errorMessage = menuError.message || menuError;
//       }
//       const paymentStatuses = ["EXPIRED", "INACTIVE", "PENDING", "PAYMENT_REQUIRED"];
//       const isPaymentError = paymentStatuses.includes(status) || menuError?.status === 403;
//       if (isPaymentError && status) {
//         setPaymentErrorData({
//           status, message: errorMessage,
//           daysRemaining: menuError.data?.daysRemaining || null,
//           canAccess: menuError.data?.canAccess || false,
//         });
//         setPaymentErrorOpen(true);
//       }
//     }
//   }, [menuError]);

//   // =========================================================
//   // ⚡ SOCKET LISTENER — Har page pe active
//   // =========================================================
//   useEffect(() => {
//     if (!socket) {
//       console.log("⚠️ Socket not ready yet");
//       return;
//     }

//     console.log("🎧 Socket listener attached in RestaurantLayout");

//     const handleOrderStatusUpdate = (data) => {
//       console.log("📩 Socket event received:", data);

//       const order = data.order || data;
//       const status = data.status || order.status;
//       const orderId = (order._id || data.orderId || "").toString();
//       const shortId = orderId.slice(-6).toUpperCase();

//       const eventKey = `${orderId}_${status}`;
//       if (lastProcessedEventRef.current === eventKey) {
//         console.log("⏭️ Duplicate event, skipped");
//         return;
//       }
//       lastProcessedEventRef.current = eventKey;
//       setTimeout(() => {
//         if (lastProcessedEventRef.current === eventKey) lastProcessedEventRef.current = "";
//       }, 1500);

//       const labels = {
//         ACCEPTED: "Order Accepted 👍",
//         PREPARING: "Kitchen is preparing your food 🍳",
//         COMPLETED: "Your order is ready! 🎉",
//         DELIVERED: "Order delivered! 😋",
//         CANCELLED: "Order cancelled ❌",
//       };

//       const msg = `Order #${shortId}: ${labels[status] || `Status updated to ${status}`}`;

//       // 🔊 Sound
//       playNotificationSound();

//       // 🍞 Toast
//       setToastAlert({
//         open: true, message: msg,
//         severity: status === "CANCELLED" ? "error" : "success",
//       });

//       // 🔔 Notifications menu me add
//       setNotifications((prev) => {
//         const isDuplicate = prev.some(
//           (n) => n.orderId === orderId && n.status === status && Date.now() - n.id < 5000
//         );
//         if (isDuplicate) return prev;
//         return [{
//           id: Date.now(), orderId, text: msg, status,
//           time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//         }, ...prev];
//       });

//       setHasUnread(true);
//     };

//     socket.on("order-status-updated", handleOrderStatusUpdate);

//     return () => {
//       socket.off("order-status-updated", handleOrderStatusUpdate);
//       console.log("🔇 Socket listener removed");
//     };
//   }, [socket, playNotificationSound]);

//   const handleRetry = () => {
//     setPaymentErrorOpen(false);
//     setPaymentErrorData(null);
//     dispatch(resetMenuError());
//     if (restaurantId) {
//       dispatch(fetchPublicMenu(restaurantId));
//       dispatch(fetchPublicOffers(restaurantId));
//     }
//   };

//   const handleTabChange = (_, newValue) => {
//     prevTabRef.current = activeTab;
//     setActiveTab(newValue);
//     setSubPage(null);
//     const identifier = restaurantInfo?.slug || restaurantId;
//     navigate(`/restaurant/${identifier}/${TABS[newValue].path}`);
//   };

//   const handleTopBarCartClick = () => {
//     const identifier = restaurantInfo?.slug || restaurantId;
//     if (activeTab !== 1) {
//       navigate(`/restaurant/${identifier}/menu`);
//       setActiveTab(1);
//     }
//     window.dispatchEvent(new CustomEvent("open-cart-drawer"));
//   };

//   const handleDeleteNotification = (e, notifId) => {
//     e.stopPropagation();
//     setNotifications((prev) => {
//       const updated = prev.filter((item) => item.id !== notifId);
//       try { localStorage.setItem(storageKey, JSON.stringify(updated)); } catch (err) {}
//       return updated;
//     });
//   };

//   const handleClearAllNotifications = () => {
//     setNotifications([]);
//     setHasUnread(false);
//     setNotifAnchorEl(null);
//     try {
//       localStorage.removeItem(storageKey);
//       if (restaurantInfo?._id) localStorage.removeItem(`rw_customer_notifs_${restaurantInfo._id}`);
//       if (restaurantInfo?.slug) localStorage.removeItem(`rw_customer_notifs_${restaurantInfo.slug}`);
//     } catch (err) {}
//   };

//   useEffect(() => {
//     const idx = TABS.findIndex((t) => t.path === lastSegment);
//     if (idx >= 0 && idx !== activeTab) setActiveTab(idx);
//   }, [location.pathname]);

//   const handleBack = () => {
//     if (subPage && closeSubPageRef.current) {
//       closeSubPageRef.current();
//       return;
//     }
//     navigate(-1);
//   };

//   const tab = TABS[activeTab] || TABS[0];

//   const SUB_PAGE_META = {
//     help: { title: "Help & Support", subtitle: "FAQs, contact & tickets", gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)" },
//     rate: { title: "Rate This Restaurant", subtitle: "Your feedback matters", gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)" },
//     about: { title: "About", subtitle: "Version, team & legal", gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)" },
//   };

//   const subMeta = subPage ? SUB_PAGE_META[subPage] : null;
//   const topTitle = subMeta ? subMeta.title : activeTab === 0 ? (restaurantInfo?.restaurantName || "Home") : tab.label;
//   const topSubtitle = subMeta ? subMeta.subtitle : activeTab === 0
//     ? (restaurantInfo?.cuisine ? (Array.isArray(restaurantInfo.cuisine) ? restaurantInfo.cuisine.join(" · ") : restaurantInfo.cuisine) : "Welcome!")
//     : tab.subtitle;
//   const activeGradient = subMeta ? subMeta.gradient : tab.gradient;

//   const renderPage = () => {
//     if (paymentErrorOpen) return null;
//     switch (activeTab) {
//       case 0: return <HomePage restaurantId={restaurantId} onTabChange={handleTabChange} />;
//       case 1: return <PublicMenuPage restaurantId={restaurantId} />;
//       case 2: return <OffersPage restaurantId={restaurantId} />;
//       case 3: return <OrdersPage restaurantId={restaurantId} restaurantInfo={restaurantInfo} />;
//       case 4: return <AccountPage restaurantId={restaurantId} onSubPageChange={handleSubPageChange} />;
//       default: return <HomePage restaurantId={restaurantId} onTabChange={handleTabChange} />;
//     }
//   };

//   if (paymentErrorOpen) {
//     return <PaymentErrorDialog open={paymentErrorOpen} errorData={paymentErrorData} onRetry={handleRetry} />;
//   }

//   return (
//     <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5", display: "flex", flexDirection: "column" }}>
//       {/* STICKY TOP BAR */}
//       <Box sx={{ position: "sticky", top: 0, zIndex: 1100, bgcolor: "white", boxShadow: "0 1px 6px rgba(0,0,0,0.08)" }}>
//         <Box sx={{ display: "flex", alignItems: "center", px: { xs: 1.2, sm: 2 }, gap: 1, minHeight: 54 }}>
//           <IconButton size="small" onClick={handleBack}
//             sx={{ width: 34, height: 34, bgcolor: "#f5f5f5", color: "#1a1a1a", flexShrink: 0, "&:hover": { bgcolor: "#ebebeb" } }}>
//             <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
//           </IconButton>

//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontWeight: 800, fontSize: { xs: "0.9rem", sm: "1rem" }, color: "#1a1a1a", lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
//               {topTitle}
//             </Typography>
//             <Typography sx={{ fontSize: "0.68rem", color: "#888", lineHeight: 1, display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
//               {topSubtitle}
//             </Typography>
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, flexShrink: 0 }}>
//             <IconButton size="small" onClick={(e) => { setNotifAnchorEl(e.currentTarget); setHasUnread(false); }}
//               sx={{ width: 36, height: 36, bgcolor: "#f5f5f5", color: "#444", "&:hover": { bgcolor: "#ebebeb" } }}>
//               <Badge color="error" variant="dot" invisible={!hasUnread && notifications.length === 0}>
//                 <NotificationsIcon sx={{ fontSize: 20 }} />
//               </Badge>
//             </IconButton>

//             <IconButton size="small" onClick={handleTopBarCartClick}
//               sx={{ width: 36, height: 36, bgcolor: "rgba(255, 107, 0, 0.1)", color: "#FF6B00", "&:hover": { bgcolor: "rgba(255, 107, 0, 0.18)" } }}>
//               <Badge badgeContent={cartCount > 0 ? cartCount : null} color="error"
//                 sx={{ "& .MuiBadge-badge": { fontSize: "0.62rem", height: 16, minWidth: 16, px: 0.4 } }}>
//                 <ShoppingCartIcon sx={{ fontSize: 20 }} />
//               </Badge>
//             </IconButton>
//           </Box>
//         </Box>

//         <Box sx={{ height: 3, background: activeGradient, transition: "background 0.3s ease" }} />
//       </Box>

//       {/* NOTIFICATIONS MENU */}
//       <Menu anchorEl={notifAnchorEl} open={isNotifOpen} onClose={() => setNotifAnchorEl(null)}
//         PaperProps={{ sx: { width: { xs: "92vw", sm: 360 }, maxWidth: 380, borderRadius: 3, boxShadow: "0 10px 30px rgba(0,0,0,0.18)", border: "1px solid #ebebeb" } }}
//         transformOrigin={{ horizontal: "right", vertical: "top" }}
//         anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
//         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2, py: 1.2 }}>
//           <Typography variant="subtitle2" sx={{ fontWeight: 800, fontSize: "0.88rem" }}>
//             Order Notifications ({notifications.length})
//           </Typography>
//           {notifications.length > 0 && (
//             <Button size="small" onClick={handleClearAllNotifications} startIcon={<ClearAllIcon sx={{ fontSize: 16 }} />}
//               sx={{ textTransform: "none", fontSize: "0.7rem", color: "#f44336", fontWeight: 700, py: 0.2 }}>
//               Clear All
//             </Button>
//           )}
//         </Box>
//         <Divider />
//         <Box sx={{ maxHeight: 290, overflowY: "auto", "&::-webkit-scrollbar": { width: 5 }, "&::-webkit-scrollbar-thumb": { bgcolor: "#d6d6d6", borderRadius: 3 } }}>
//           {notifications.length === 0 ? (
//             <Box sx={{ p: 4, textAlign: "center" }}>
//               <Typography variant="body2" sx={{ color: "#888", fontSize: "0.82rem" }}>No active notifications</Typography>
//             </Box>
//           ) : (
//             notifications.map((n) => (
//               <MenuItem key={n.id}
//                 onClick={() => { setNotifAnchorEl(null); handleTabChange(null, 3); }}
//                 sx={{ py: 1.2, px: 1.8, display: "flex", alignItems: "flex-start", gap: 1.2, borderBottom: "1px solid #f2f2f2", "&:hover": { bgcolor: "#fff8f3" } }}>
//                 <ListItemIcon sx={{ minWidth: 26, mt: 0.3 }}>
//                   <CheckCircleIcon sx={{ fontSize: 18, color: "#2e7d32" }} />
//                 </ListItemIcon>
//                 <Box sx={{ flex: 1, minWidth: 0 }}>
//                   <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#1a1a1a", whiteSpace: "normal", wordBreak: "break-word", lineHeight: 1.35 }}>
//                     {n.text}
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: "#999", fontSize: "0.68rem", mt: 0.3, display: "block" }}>
//                     {n.time}
//                   </Typography>
//                 </Box>
//                 <Tooltip title="Delete">
//                   <IconButton size="small" onClick={(e) => handleDeleteNotification(e, n.id)}
//                     sx={{ p: 0.5, color: "#aaa", flexShrink: 0, "&:hover": { color: "#f44336", bgcolor: "#ffebee" } }}>
//                     <DeleteOutlineIcon sx={{ fontSize: 16 }} />
//                   </IconButton>
//                 </Tooltip>
//               </MenuItem>
//             ))
//           )}
//         </Box>
//       </Menu>

//       {/* PAGE CONTENT */}
//       <Box sx={{ flex: 1, pb: "56px" }}>{renderPage()}</Box>

//       {/* BOTTOM NAV */}
//       {!(activeTab === 4 && subPage) && (
//         <Paper elevation={8}
//           sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1200, borderTop: "1px solid #ebebeb", borderRadius: 0 }}>
//           <BottomNavigation value={activeTab} onChange={handleTabChange} showLabels
//             sx={{
//               height: 56, bgcolor: "white",
//               "& .MuiBottomNavigationAction-root": { minWidth: 0, px: 0.5, fontSize: "0.65rem", color: "#9e9e9e" },
//               "& .Mui-selected": {
//                 color: `${TABS[activeTab]?.accentColor || "#FF6B00"} !important`,
//                 "& .MuiBottomNavigationAction-label": { fontSize: "0.65rem !important", fontWeight: 700 },
//               },
//             }}>
//             <BottomNavigationAction label="Home" icon={<HomeIcon sx={{ fontSize: 22 }} />} />
//             <BottomNavigationAction label="Menu"
//               icon={<Badge badgeContent={cartCount > 0 ? cartCount : null} color="error"
//                 sx={{ "& .MuiBadge-badge": { fontSize: "0.6rem", minWidth: 16, height: 16 } }}>
//                 <RestaurantMenuIcon sx={{ fontSize: 22 }} />
//               </Badge>} />
//             <BottomNavigationAction label="Offers"
//               icon={<Badge badgeContent={offersCount > 0 ? offersCount : null} color="success"
//                 sx={{ "& .MuiBadge-badge": { fontSize: "0.6rem", minWidth: 16, height: 16 } }}>
//                 <Box sx={{
//                   width: 44, height: 44, borderRadius: "50%",
//                   bgcolor: activeTab === 2 ? "#FF6B00" : "#fff",
//                   display: "flex", alignItems: "center", justifyContent: "center",
//                   mt: -1.5,
//                   boxShadow: activeTab === 2 ? "0 4px 12px rgba(255,107,0,0.45)" : "0 2px 8px rgba(0,0,0,0.1)",
//                   border: "2px solid white",
//                 }}>
//                   <LocalOfferIcon sx={{ fontSize: 20, color: activeTab === 2 ? "white" : "#FF6B00" }} />
//                 </Box>
//               </Badge>}
//               sx={{ "& .MuiBottomNavigationAction-label": { mt: 0.5 } }} />
//             <BottomNavigationAction label="Orders" icon={<ReceiptLongIcon sx={{ fontSize: 22 }} />} />
//             <BottomNavigationAction label="Account" icon={<PersonOutlineIcon sx={{ fontSize: 22 }} />} />
//           </BottomNavigation>
//         </Paper>
//       )}

//       {/* TOAST */}
//       <Snackbar open={toastAlert.open} autoHideDuration={4500}
//         onClose={() => setToastAlert((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}>
//         <Alert severity={toastAlert.severity} variant="filled"
//           onClose={() => setToastAlert((prev) => ({ ...prev, open: false }))}
//           sx={{ borderRadius: 3, fontWeight: 700, fontSize: "0.82rem", boxShadow: "0 8px 24px rgba(0,0,0,0.2)", cursor: "pointer" }}
//           onClick={() => { setToastAlert((prev) => ({ ...prev, open: false })); handleTabChange(null, 3); }}>
//           {toastAlert.message}
//         </Alert>
//       </Snackbar>

//       <PaymentErrorDialog open={paymentErrorOpen} errorData={paymentErrorData} onRetry={handleRetry} />
//     </Box>
//   );
// };

// export default RestaurantLayout;


import { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Badge,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Snackbar,
  Alert,
  Tooltip,
  Chip,
  Button,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff"; // 🔇 Mute Icon
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchPublicMenu,
  fetchPublicOffers,
  selectRestaurantInfo,
  selectMenuError,
  selectMenuLoading,
  resetMenuError,
} from "../../redux/slices/publicSlice";
import { useSocket } from "../../context/SocketContext";
import PaymentErrorDialog from "./PaymentErrorDialog";

// Import all tab pages
import HomePage from "./tabs/HomePage";
import PublicMenuPage from "./tabs/PublicMenuPage";
import OffersPage from "./tabs/OffersPage";
import OrdersPage from "./tabs/OrdersPage";
import AccountPage from "./tabs/AccountPage";

// ── Tab config ────────────────────────────────────
const TABS = [
  {
    label: "Home",
    path: "home",
    subtitle: "Welcome!",
    accentColor: "#FF6B00",
    gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
    hasOwnAppBar: false,
  },
  {
    label: "Menu",
    path: "menu",
    subtitle: "Browse & order",
    accentColor: "#FF6B00",
    gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
    hasOwnAppBar: true,
  },
  {
    label: "Offers",
    path: "offers",
    subtitle: "Deals & discounts",
    accentColor: "#FF6B00",
    gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
    hasOwnAppBar: false,
  },
  {
    label: "Orders",
    path: "orders",
    subtitle: "Your order history",
    accentColor: "#FF6B00",
    gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
    hasOwnAppBar: false,
  },
  {
    label: "Account",
    path: "account",
    subtitle: "Profile & settings",
    accentColor: "#FF6B00",
    gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
    hasOwnAppBar: false,
  },
];

const RestaurantLayout = () => {
  const { restaurantId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const prevTabRef = useRef(0);
  const closeSubPageRef = useRef(null);
  const { socket } = useSocket();

  // 🔊 Audio Reference & Unlock Status
  const audioRef = useRef(null);
  const audioUnlockedRef = useRef(false);

  // 🔔 Order Notification Sound Toggle State (Default check from localStorage)
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(() => {
    const saved = localStorage.getItem("rw_sound_notification_enabled");
    return saved !== null ? JSON.parse(saved) : true;
  });

  // Redux states
  const restaurantInfo = useSelector(selectRestaurantInfo);
  const menuError = useSelector(selectMenuError);
  const menuLoading = useSelector(selectMenuLoading);

  // Payment Error Dialog State
  const [paymentErrorOpen, setPaymentErrorOpen] = useState(false);
  const [paymentErrorData, setPaymentErrorData] = useState(null);

  const effectiveKey = restaurantInfo?.slug || restaurantId || "default";
  const storageKey = `rw_customer_notifs_${effectiveKey}`;

  const [notifications, setNotifications] = useState(() => {
    try {
      const saved =
        localStorage.getItem(`rw_customer_notifs_${restaurantId}`) ||
        localStorage.getItem(storageKey);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const isLoadedRef = useRef(false);
  const lastProcessedEventRef = useRef("");

  const [hasUnread, setHasUnread] = useState(false);
  const [notifAnchorEl, setNotifAnchorEl] = useState(null);
  const isNotifOpen = Boolean(notifAnchorEl);

  const [toastAlert, setToastAlert] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  // 👂 Account page se Notification Toggle change hone par listen karein
  useEffect(() => {
    const handleNotificationToggle = (e) => {
      const isEnabled = e.detail?.enabled;
      setIsNotificationEnabled(isEnabled);
    };

    window.addEventListener("order-notification-toggle", handleNotificationToggle);
    return () => {
      window.removeEventListener("order-notification-toggle", handleNotificationToggle);
    };
  }, []);

  // 🔊 Audio Setup & Autoplay Unlock
  useEffect(() => {
    const audio = new Audio("/sounds/notification.mp3");
    audio.preload = "auto";
    audio.volume = 1.0;
    audioRef.current = audio;

    const unlockAudio = () => {
      if (audioRef.current && !audioUnlockedRef.current) {
        audioRef.current
          .play()
          .then(() => {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioUnlockedRef.current = true;
          })
          .catch(() => {});
      }
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
    };

    window.addEventListener("click", unlockAudio, { once: true });
    window.addEventListener("touchstart", unlockAudio, { once: true });

    return () => {
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
    };
  }, []);

  // 🔔 Safe Sound Play Function (Respects mute toggle)
  const playNotificationSound = () => {
    // ⭐ Agar notification disabled (false) hai to sound play mat karo
    const currentEnabled = (() => {
      const saved = localStorage.getItem("rw_sound_notification_enabled");
      return saved !== null ? JSON.parse(saved) : true;
    })();

    if (!currentEnabled) {
      console.log("🔇 Notification sound is muted by user");
      return;
    }

    try {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        const playPromise = audioRef.current.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            const backupSound = new Audio("/sounds/notification.mp3");
            backupSound.volume = 1.0;
            backupSound.play().catch((err) => {
              console.warn("Autoplay restriction prevented sound:", err);
            });
          });
        }
      }
    } catch (err) {
      console.warn("Audio error:", err);
    }
  };

  useEffect(() => {
    try {
      const saved =
        localStorage.getItem(`rw_customer_notifs_${restaurantInfo?.slug}`) ||
        localStorage.getItem(`rw_customer_notifs_${restaurantInfo?._id}`) ||
        localStorage.getItem(`rw_customer_notifs_${restaurantId}`);

      if (saved) {
        setNotifications(JSON.parse(saved));
      }
    } catch (e) {
      console.error("Storage load error:", e);
    } finally {
      isLoadedRef.current = true;
    }
  }, [restaurantInfo?.slug, restaurantInfo?._id, restaurantId]);

  useEffect(() => {
    if (!isLoadedRef.current) return;
    try {
      localStorage.setItem(storageKey, JSON.stringify(notifications));
      if (restaurantInfo?._id) {
        localStorage.setItem(
          `rw_customer_notifs_${restaurantInfo._id}`,
          JSON.stringify(notifications)
        );
      }
      if (restaurantInfo?.slug) {
        localStorage.setItem(
          `rw_customer_notifs_${restaurantInfo.slug}`,
          JSON.stringify(notifications)
        );
      }
    } catch (e) {
      console.error("Failed to save notifications to storage:", e);
    }
  }, [notifications, storageKey, restaurantInfo]);

  const [subPage, setSubPage] = useState(null);
  const handleSubPageChange = useCallback((pageOrFalse, closeFn) => {
    setSubPage(pageOrFalse || null);
    if (closeFn) closeSubPageRef.current = closeFn;
    if (!pageOrFalse) closeSubPageRef.current = null;
  }, []);

  const lastSegment = location.pathname.split("/").pop();
  const tabIndex = TABS.findIndex((t) => t.path === lastSegment);
  const [activeTab, setActiveTab] = useState(tabIndex >= 0 ? tabIndex : 0);

  const cartItems = useSelector((s) => s.cart?.items || []);
  const cartCount = cartItems.reduce((n, i) => n + (i.qty || 0), 0);

  const allOffers = useSelector((s) => s.public?.offers || []);
  const offersCount = allOffers.length;

  useEffect(() => {
    if (restaurantId) {
      dispatch(resetMenuError());
      dispatch(fetchPublicMenu(restaurantId));
      dispatch(fetchPublicOffers(restaurantId));
    }
    return () => {
      dispatch(resetMenuError());
    };
  }, [restaurantId, dispatch]);

  useEffect(() => {
    if (menuError) {
      let status = null;
      let errorMessage = "This restaurant is currently unavailable.";

      if (menuError.data?.status) {
        status = menuError.data.status;
        errorMessage = menuError.message || menuError;
      } else if (menuError.status && typeof menuError.status === "string") {
        status = menuError.status;
        errorMessage = menuError.message || menuError;
      } else if (menuError.success === false && menuError.data?.status) {
        status = menuError.data.status;
        errorMessage = menuError.message || menuError;
      }

      const paymentStatuses = ["EXPIRED", "INACTIVE", "PENDING", "PAYMENT_REQUIRED"];
      const isPaymentError = paymentStatuses.includes(status) || menuError?.status === 403;

      if (isPaymentError && status) {
        setPaymentErrorData({
          status: status,
          message: errorMessage,
          daysRemaining: menuError.data?.daysRemaining || null,
          canAccess: menuError.data?.canAccess || false,
        });
        setPaymentErrorOpen(true);
      }
    }
  }, [menuError]);

  // ⚡ Socket Status Listener
  useEffect(() => {
    if (!socket) return;

    const handleOrderStatusUpdate = (data) => {
      const order = data.order || data;
      const status = data.status || order.status;
      const orderId = (order._id || data.orderId || "").toString();
      const shortId = orderId.slice(-6).toUpperCase();

      const eventKey = `${orderId}_${status}`;
      if (lastProcessedEventRef.current === eventKey) return;
      lastProcessedEventRef.current = eventKey;
      setTimeout(() => {
        if (lastProcessedEventRef.current === eventKey) {
          lastProcessedEventRef.current = "";
        }
      }, 1500);

      const labels = {
        ACCEPTED: "Order Accepted 👍",
        PREPARING: "Kitchen is preparing your food 🍳",
        COMPLETED: "Your order is ready! 🎉",
        DELIVERED: "Order delivered! 😋",
        CANCELLED: "Order cancelled ❌",
      };

      const msg = `Order #${shortId}: ${labels[status] || `Status updated to ${status}`}`;

      // 🔊 Play Chime Sound (Check if enabled)
      playNotificationSound();

      setToastAlert({
        open: true,
        message: msg,
        severity: status === "CANCELLED" ? "error" : "success",
      });

      setNotifications((prev) => [
        {
          id: Date.now(),
          orderId: orderId,
          text: msg,
          status,
          time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        },
        ...prev,
      ]);

      setHasUnread(true);
    };

    socket.on("order-status-updated", handleOrderStatusUpdate);

    return () => {
      socket.off("order-status-updated", handleOrderStatusUpdate);
    };
  }, [socket]);

  const handleRetry = () => {
    setPaymentErrorOpen(false);
    setPaymentErrorData(null);
    dispatch(resetMenuError());
    if (restaurantId) {
      dispatch(fetchPublicMenu(restaurantId));
      dispatch(fetchPublicOffers(restaurantId));
    }
  };

  const handleTabChange = (_, newValue) => {
    prevTabRef.current = activeTab;
    setActiveTab(newValue);
    setSubPage(null);
    const identifier = restaurantInfo?.slug || restaurantId;
    navigate(`/restaurant/${identifier}/${TABS[newValue].path}`);
  };

  const handleTopBarCartClick = () => {
    const identifier = restaurantInfo?.slug || restaurantId;
    if (activeTab !== 1) {
      navigate(`/restaurant/${identifier}/menu`);
      setActiveTab(1);
    }
    window.dispatchEvent(new CustomEvent("open-cart-drawer"));
  };

  const handleDeleteNotification = (e, notifId) => {
    e.stopPropagation();
    setNotifications((prev) => {
      const updated = prev.filter((item) => item.id !== notifId);
      try {
        localStorage.setItem(storageKey, JSON.stringify(updated));
      } catch (err) {}
      return updated;
    });
  };

  const handleClearAllNotifications = () => {
    setNotifications([]);
    setHasUnread(false);
    setNotifAnchorEl(null);
    try {
      localStorage.removeItem(storageKey);
      if (restaurantInfo?._id)
        localStorage.removeItem(`rw_customer_notifs_${restaurantInfo._id}`);
      if (restaurantInfo?.slug)
        localStorage.removeItem(`rw_customer_notifs_${restaurantInfo.slug}`);
    } catch (err) {}
  };

  useEffect(() => {
    const idx = TABS.findIndex((t) => t.path === lastSegment);
    if (idx >= 0 && idx !== activeTab) setActiveTab(idx);
  }, [location.pathname]);

  const handleBack = () => {
    if (subPage && closeSubPageRef.current) {
      closeSubPageRef.current();
      return;
    }
    navigate(-1);
  };

  const tab = TABS[activeTab] || TABS[0];

  const SUB_PAGE_META = {
    help: {
      title: "Help & Support",
      subtitle: "FAQs, contact & tickets",
      gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
    },
    rate: {
      title: "Rate This Restaurant",
      subtitle: "Your feedback matters",
      gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
    },
    about: {
      title: "About",
      subtitle: "Version, team & legal",
      gradient: "linear-gradient(90deg, #E85A00, #FF6B00, #FFA94D)",
    },
  };

  const subMeta = subPage ? SUB_PAGE_META[subPage] : null;

  const topTitle = subMeta
    ? subMeta.title
    : activeTab === 0
      ? restaurantInfo?.restaurantName || "Home"
      : tab.label;

  const topSubtitle = subMeta
    ? subMeta.subtitle
    : activeTab === 0
      ? restaurantInfo?.cuisine
        ? Array.isArray(restaurantInfo.cuisine)
          ? restaurantInfo.cuisine.join(" · ")
          : restaurantInfo.cuisine
        : "Welcome!"
      : tab.subtitle;

  const activeGradient = subMeta ? subMeta.gradient : tab.gradient;

  const renderPage = () => {
    if (paymentErrorOpen) return null;

    switch (activeTab) {
      case 0:
        return <HomePage restaurantId={restaurantId} onTabChange={handleTabChange} />;
      case 1:
        return <PublicMenuPage restaurantId={restaurantId} />;
      case 2:
        return <OffersPage restaurantId={restaurantId} />;
      case 3:
        return <OrdersPage restaurantId={restaurantId} restaurantInfo={restaurantInfo} />;
      case 4:
        return (
          <AccountPage
            restaurantId={restaurantId}
            onSubPageChange={handleSubPageChange}
          />
        );
      default:
        return <HomePage restaurantId={restaurantId} onTabChange={handleTabChange} />;
    }
  };

  if (paymentErrorOpen) {
    return (
      <PaymentErrorDialog
        open={paymentErrorOpen}
        errorData={paymentErrorData}
        onRetry={handleRetry}
      />
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ══ STICKY TOP BAR ══ */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1100,
          bgcolor: "white",
          boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            px: { xs: 1.2, sm: 2 },
            gap: 1,
            minHeight: 54,
          }}
        >
          <IconButton
            size="small"
            onClick={handleBack}
            sx={{
              width: 34,
              height: 34,
              bgcolor: "#f5f5f5",
              color: "#1a1a1a",
              flexShrink: 0,
              "&:hover": { bgcolor: "#ebebeb" },
              transition: "background 0.15s",
            }}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
          </IconButton>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: { xs: "0.9rem", sm: "1rem" },
                color: "#1a1a1a",
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {topTitle}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.68rem",
                color: "#888",
                lineHeight: 1,
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {topSubtitle}
            </Typography>
          </Box>

          {/* 🔔 Right Side Icons */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, flexShrink: 0 }}>
            {/* Notification Bell / Mute Icon */}
            <Tooltip title={isNotificationEnabled ? "Notifications Active" : "Notifications Muted"}>
              <IconButton
                size="small"
                onClick={(e) => {
                  setNotifAnchorEl(e.currentTarget);
                  setHasUnread(false);
                }}
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: isNotificationEnabled ? "#f5f5f5" : "#fff0f0",
                  color: isNotificationEnabled ? "#444" : "#d32f2f",
                  "&:hover": { bgcolor: isNotificationEnabled ? "#ebebeb" : "#ffebee" },
                }}
              >
                <Badge color="error" variant="dot" invisible={!hasUnread && notifications.length === 0}>
                  {isNotificationEnabled ? (
                    <NotificationsIcon sx={{ fontSize: 20 }} />
                  ) : (
                    <NotificationsOffIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
                  )}
                </Badge>
              </IconButton>
            </Tooltip>

            {/* Cart Icon */}
            <IconButton
              size="small"
              onClick={handleTopBarCartClick}
              sx={{
                width: 36,
                height: 36,
                bgcolor: "rgba(255, 107, 0, 0.1)",
                color: "#FF6B00",
                "&:hover": { bgcolor: "rgba(255, 107, 0, 0.18)" },
              }}
            >
              <Badge
                badgeContent={cartCount > 0 ? cartCount : null}
                color="error"
                sx={{
                  "& .MuiBadge-badge": {
                    fontSize: "0.62rem",
                    height: 16,
                    minWidth: 16,
                    px: 0.4,
                  },
                }}
              >
                <ShoppingCartIcon sx={{ fontSize: 20 }} />
              </Badge>
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            height: 3,
            background: activeGradient,
            transition: "background 0.3s ease",
          }}
        />
      </Box>

      {/* ══ RESPONSIVE NOTIFICATION DROPDOWN MENU ══ */}
      <Menu
        anchorEl={notifAnchorEl}
        open={isNotifOpen}
        onClose={() => setNotifAnchorEl(null)}
        PaperProps={{
          sx: {
            width: { xs: "92vw", sm: 360 },
            maxWidth: 380,
            borderRadius: 3,
            boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
            border: "1px solid #ebebeb",
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1.2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, fontSize: "0.88rem" }}>
              Order Notifications ({notifications.length})
            </Typography>
            {!isNotificationEnabled && (
              <Chip
                label="Muted"
                size="small"
                sx={{
                  height: 18,
                  fontSize: "0.6rem",
                  bgcolor: "#ffebee",
                  color: "#d32f2f",
                  fontWeight: 700,
                }}
              />
            )}
          </Box>
          {notifications.length > 0 && (
            <Button
              size="small"
              onClick={handleClearAllNotifications}
              startIcon={<ClearAllIcon sx={{ fontSize: 16 }} />}
              sx={{
                textTransform: "none",
                fontSize: "0.7rem",
                color: "#f44336",
                fontWeight: 700,
                py: 0.2,
              }}
            >
              Clear All
            </Button>
          )}
        </Box>
        <Divider />

        {/* 📜 4-5 Notifications Display with Clean Scrollbar */}
        <Box
          sx={{
            maxHeight: 290,
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: 5 },
            "&::-webkit-scrollbar-thumb": {
              bgcolor: "#d6d6d6",
              borderRadius: 3,
            },
          }}
        >
          {notifications.length === 0 ? (
            <Box sx={{ p: 4, textAlign: "center" }}>
              <Typography variant="body2" sx={{ color: "#888", fontSize: "0.82rem" }}>
                No active notifications
              </Typography>
            </Box>
          ) : (
            notifications.map((n) => (
              <MenuItem
                key={n.id}
                onClick={() => {
                  setNotifAnchorEl(null);
                  handleTabChange(null, 3);
                }}
                sx={{
                  py: 1.2,
                  px: 1.8,
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.2,
                  borderBottom: "1px solid #f2f2f2",
                  "&:hover": { bgcolor: "#fff8f3" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 26, mt: 0.3 }}>
                  <CheckCircleIcon sx={{ fontSize: 18, color: "#2e7d32" }} />
                </ListItemIcon>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      fontSize: "0.8rem",
                      color: "#1a1a1a",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      lineHeight: 1.35,
                    }}
                  >
                    {n.text}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: "#999", fontSize: "0.68rem", mt: 0.3, display: "block" }}
                  >
                    {n.time}
                  </Typography>
                </Box>

                <Tooltip title="Delete">
                  <IconButton
                    size="small"
                    onClick={(e) => handleDeleteNotification(e, n.id)}
                    sx={{
                      p: 0.5,
                      color: "#aaa",
                      flexShrink: 0,
                      "&:hover": { color: "#f44336", bgcolor: "#ffebee" },
                    }}
                  >
                    <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
              </MenuItem>
            ))
          )}
        </Box>
      </Menu>

      {/* ══ PAGE CONTENT ════════════════════════════════════════════ */}
      <Box sx={{ flex: 1, pb: "56px" }}>{renderPage()}</Box>

      {/* ══ FIXED BOTTOM NAVIGATION ══ */}
      {!(activeTab === 4 && subPage) && (
        <Paper
          elevation={8}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1200,
            borderTop: "1px solid #ebebeb",
            borderRadius: 0,
          }}
        >
          <BottomNavigation
            value={activeTab}
            onChange={handleTabChange}
            showLabels
            sx={{
              height: 56,
              bgcolor: "white",
              "& .MuiBottomNavigationAction-root": {
                minWidth: 0,
                px: 0.5,
                fontSize: "0.65rem",
                color: "#9e9e9e",
                transition: "color 0.2s",
              },
              "& .Mui-selected": {
                color: `${TABS[activeTab]?.accentColor || "#FF6B00"} !important`,
                "& .MuiBottomNavigationAction-label": {
                  fontSize: "0.65rem !important",
                  fontWeight: 700,
                },
              },
            }}
          >
            <BottomNavigationAction label="Home" icon={<HomeIcon sx={{ fontSize: 22 }} />} />
            <BottomNavigationAction
              label="Menu"
              icon={
                <Badge
                  badgeContent={cartCount > 0 ? cartCount : null}
                  color="error"
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.6rem",
                      minWidth: 16,
                      height: 16,
                    },
                  }}
                >
                  <RestaurantMenuIcon sx={{ fontSize: 22 }} />
                </Badge>
              }
            />
            <BottomNavigationAction
              label="Offers"
              icon={
                <Badge
                  badgeContent={offersCount > 0 ? offersCount : null}
                  color="success"
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.6rem",
                      minWidth: 16,
                      height: 16,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      bgcolor: activeTab === 2 ? "#FF6B00" : "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: -1.5,
                      boxShadow:
                        activeTab === 2
                          ? "0 4px 12px rgba(255,107,0,0.45)"
                          : "0 2px 8px rgba(0,0,0,0.1)",
                      transition: "all 0.2s",
                      border: "2px solid white",
                    }}
                  >
                    <LocalOfferIcon
                      sx={{
                        fontSize: 20,
                        color: activeTab === 2 ? "white" : "#FF6B00",
                      }}
                    />
                  </Box>
                </Badge>
              }
              sx={{ "& .MuiBottomNavigationAction-label": { mt: 0.5 } }}
            />
            <BottomNavigationAction label="Orders" icon={<ReceiptLongIcon sx={{ fontSize: 22 }} />} />
            <BottomNavigationAction label="Account" icon={<PersonOutlineIcon sx={{ fontSize: 22 }} />} />
          </BottomNavigation>
        </Paper>
      )}

      {/* ══ REAL-TIME ORDER UPDATE TOAST ══ */}
      <Snackbar
        open={toastAlert.open}
        autoHideDuration={4500}
        onClose={() => setToastAlert((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={toastAlert.severity}
          variant="filled"
          onClose={() => setToastAlert((prev) => ({ ...prev, open: false }))}
          sx={{
            borderRadius: 3,
            fontWeight: 700,
            fontSize: "0.82rem",
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            cursor: "pointer",
          }}
          onClick={() => {
            setToastAlert((prev) => ({ ...prev, open: false }));
            handleTabChange(null, 3);
          }}
        >
          {toastAlert.message}
        </Alert>
      </Snackbar>

      {/* Payment Error Dialog - Fallback */}
      <PaymentErrorDialog
        open={paymentErrorOpen}
        errorData={paymentErrorData}
        onRetry={handleRetry}
      />
    </Box>
  );
};

export default RestaurantLayout;